import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Services from '../views/Services.vue'

Vue.use(VueRouter)

const routes = [

	{
		path: '/hr/',
		name: 'hr',

		// route level code-splitting
		// this generates a separate chunk (hr.[hash].js) for this route
		// which is lazy-loaded when the route is visited.

		component: () => import(

			'../views/Hres.vue'
		)
	}

	,{
		path: '/hr/:id/',
		name: 'hrprofile',
		pathToRegexpOptions: { strict: true },

		// route level code-splitting
		// this generates a separate chunk (hrprofile.[hash].js) for this route
		// which is lazy-loaded when the route is visited.

		component: () => import(

			'../views/Hrprofile.vue'
		)
	}

	,{
		path: '/profile/:id/',
		name: 'profileview',
		pathToRegexpOptions: { strict: true },

		// route level code-splitting
		// this generates a separate chunk (profileview.[hash].js) for this route
		// which is lazy-loaded when the route is visited.

		component: () => import(

			'../views/Profileview.vue'
		)
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: routes
});


export default router


router.beforeEach(
	(to, from, next)=>{
		console.log('beforeEach()', to.matched[0]);
		next();
	/*
		if ( 
			to.name !== 'login' 
			&&
			!this.isloggedin
		){
			next(
				{
					path: 'login'
					,replace: true
				}
			)
		} else {
			next();
		}
	*/
	} 
);
